import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntBackLightingPipe} from "./int-back-lighting.pipe";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    IntBackLightingPipe
  ],
  exports: [
    IntBackLightingPipe
  ]
})
export class IntBackLightingModule {}
